import { Grid, IconButton, Tooltip } from '@mui/material';
import LinkIcon from '@mui/icons-material/Link';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import CachedIcon from '@mui/icons-material/Cached';
import { ChatAssistantListActionsProps } from './props';
import { useChatAssistantActions } from './hook';

export const ChatAssistantsListActions = ({
    id,
    assistantLinkId,
    reloadData,
    isAuthUser,
}: ChatAssistantListActionsProps) => {
    const { handleEdit, handleDelete, handleGoToAssistant, handleUpdateLink } =
        useChatAssistantActions(id, reloadData, assistantLinkId);

    return (
        <Grid textAlign="left" width="100%">
            <Tooltip title="Link">
                <IconButton size="small" onClick={handleGoToAssistant}>
                    <LinkIcon type="submit" sx={{ color: 'primary.main' }} />
                </IconButton>
            </Tooltip>
            {isAuthUser && (
                <>
                    <Tooltip title="Editar">
                        <IconButton size="small" onClick={handleEdit}>
                            <EditIcon
                                type="submit"
                                sx={{ color: 'primary.main' }}
                            />
                        </IconButton>
                    </Tooltip>

                    <Tooltip title="Eliminar">
                        <IconButton size="small" onClick={handleDelete}>
                            <DeleteIcon
                                type="submit"
                                sx={{ color: 'primary.main' }}
                            />
                        </IconButton>
                    </Tooltip>
                    <Tooltip title="Generar nuevo link">
                        <IconButton size="small" onClick={handleUpdateLink}>
                            <CachedIcon
                                type="submit"
                                sx={{ color: 'primary.main' }}
                            />
                        </IconButton>
                    </Tooltip>
                </>
            )}
        </Grid>
    );
};
